import { render, staticRenderFns } from "./auto-card.vue?vue&type=template&id=95bd1a2e&scoped=true"
import script from "./auto-card.ts?vue&type=script&lang=ts&external"
export * from "./auto-card.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bd1a2e",
  null
  
)

export default component.exports